import { Close } from "@mui/icons-material";
import PaidIcon from "@mui/icons-material/Paid";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  TableContainer,
  Tooltip,
} from "@mui/material";
import React from "react";
import HeaderLabelTitle from "../unit/HeaderLabelTitle";
import InfoIcon from "@mui/icons-material/Info";
const CollateralDetailDialog = ({ ...props }) => {
  const data = props?.data;
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Tooltip title="Collateral Detail" placement="left">
        <InfoIcon
          sx={{
            float: "right",
            fontSize: 22,
            mt: -4,
            mb: 5,
            ml: -200,
            cursor: "pointer",
            color: "#1976d2",
            "&:hover": { color: "#0b4f94ff" },
          }}
          onClick={() => setOpen(true)}
        />
        {/* <Link
          onClick={() => setOpen(true)}
          sx={{
            float: "right",
            fontSize: "0.875rem",
            mt: "-30px",
            mb: 5,
            ml: -220,
            mr: "140px",
            cursor: "pointer",
            color: "#1976d2",
            "&:hover": { color: "#0b4f94ff" },
          }}
        >
          More
        </Link> */}
      </Tooltip>
      <Dialog
        id="dialog-app-collateral-detail"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        aria-labelledby="draggable-dialog-title"
        className=""
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Collateral Detail
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TableContainer
            sx={{
              maxWidth: "100%",
              width: "100%",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              borderRadius: 0,
              "& .MuiTableRow-head": {
                border: "none",
              },
            }}
          >
            <table className="table table-bordered">
              <tbody>
                {data?.haveCarDetail == "Yes" && (
                  <>
                    <tr>
                      <th>
                        <HeaderLabelTitle title="VIN" />
                      </th>
                      <td>{data?.car_vin || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        <HeaderLabelTitle title="Make" />
                      </th>
                      <td>{data?.car_make || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        <HeaderLabelTitle title="Model" />
                      </th>
                      <td>{data?.car_model || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        <HeaderLabelTitle title="Year" />
                      </th>
                      <td>{data?.car_year || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        <HeaderLabelTitle title="Miles" />
                      </th>
                      <td>{data?.car_mileage || "-"}</td>
                    </tr>

                    <tr>
                      <th>
                        <HeaderLabelTitle title="Estimated Value ($)" />
                      </th>
                      <td>{data?.car_detail_estimatedvalue || "-"}</td>
                    </tr>
                    <tr>
                      <th>
                        <HeaderLabelTitle title="Value Estimate Source" />
                      </th>
                      <td>{data?.car_detail_valueEstimateSource || "-"}</td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CollateralDetailDialog;
